// Formats an ISO timestamp the way the sent-history table shows it: "13-iyun, 09:00"
// (uz) / "13 июня, 09:00" (ru). UTC parts are used so the displayed time matches the
// seed data regardless of the viewer's timezone.
const MONTHS: Record<string, string[]> = {
  uz: [
    "yanvar", "fevral", "mart", "aprel", "may", "iyun",
    "iyul", "avgust", "sentyabr", "oktyabr", "noyabr", "dekabr",
  ],
  ru: [
    "января", "февраля", "марта", "апреля", "мая", "июня",
    "июля", "августа", "сентября", "октября", "ноября", "декабря",
  ],
};

export function formatNotifDate(iso: string, lang: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const months = MONTHS[lang] ?? MONTHS.uz;
  const day = d.getUTCDate();
  const month = months[d.getUTCMonth()];
  const hh = String(d.getUTCHours()).padStart(2, "0");
  const mm = String(d.getUTCMinutes()).padStart(2, "0");
  // uz uses "13-iyun", ru uses "13 июня".
  const sep = lang === "ru" ? " " : "-";
  return `${day}${sep}${month}, ${hh}:${mm}`;
}

// Group-separated integer: 64280 → "64 280". "—" for null.
export function formatCount(n: number | null): string {
  if (n === null) return "—";
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
